import { isNullOrUndefined } from 'util';
import { BrightLocalService } from './../../providers/bright-local.service';
import { CacheMiddlewareService } from './../../providers/cache-middleware.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseService } from './../../providers/firebase.service';
import { Component, OnInit } from '@angular/core';
import { FirebaseObjectObservable } from "angularfire2/database-deprecated";
import { Client } from "../../models/client";
import 'rxjs/add/operator/toPromise';
import { GeneralConnectorService } from '../../providers/general-connector.service';
import { MdSlideToggleChange } from '@angular/material';
import { environment } from '../../../environments/environment';

class Review {
  rating: string;
  author: string;
  time: Date;
  text: string;
  source: string;
  link: string;
  showOnWeb = false;

  constructor(rating, author, time, text, source, link = '') {
    this.rating = rating;
    this.author = author;
    this.time = time;
    this.text = text;
    this.source = source;
    this.link = link;
  }
}

interface ProfileUrl {
  reviews?: Array<Review>;
  url: string;
}

class FacilityReviewsData {
  isActive = false;
  urls: Array<ProfileUrl> = [];
  batchId: number;
  activeIndex: number = 0;
  status = 'no-batch';
  locationCode = '';
  facilityKey = '';
}

@Component({
  selector: 'app-facility-reviews',
  templateUrl: './facility-reviews.component.html',
  styleUrls: ['./facility-reviews.component.scss']
})
export class FacilityReviewsComponent implements OnInit {
  key: string;
  client: FirebaseObjectObservable<Client>;
  clientData: Client;
  public facilityReviewsData = new FacilityReviewsData();
  items = [];
  newProfileUrl = '';
  public isLoading = false;
  public error: string;
  showLoading = false;
  locations: any;
  selectedLocation: any;
  googleString: string;

  locationStatus = [];

  get isProd() {
    return environment.env === 'prod'
  }

  constructor(
    public afService: FirebaseService,
    private router: Router,
    private route: ActivatedRoute,
    public cacheMw: CacheMiddlewareService,
    private bl: BrightLocalService,
    private gConn: GeneralConnectorService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe((params) => {
      this.key = params['key'];
      this.cacheMw.selectedClientKey = this.key;
      this.client = this.afService.getClientInfo(this.key);

      let sub = this.afService.getClientInfo(this.key).subscribe((clientData) => {
        this.clientData = clientData;
        if (isNullOrUndefined(this.clientData.reviewSettings)) {
          this.clientData.reviewSettings = {
            isActive: false,
            updateEachMonth: false,
            reviewsArn: '',
            reviewsRetrieveArn: '',
            minimumRating: 4
          };
          this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings);
        }
        if (!this.clientData.reviewSettings.minimumRating) {
          this.clientData.reviewSettings.minimumRating = 4;
          this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings);
        }
        this.locations = this.afService.getLocations(clientData);
        let sub2 = this.afService.getLocations(clientData).subscribe((locations) => {
          this.locationStatus = [];
          for (let loc of locations) {
            let reviews = {};
            if (!isNullOrUndefined(loc['reviews'])) {
              reviews = loc['reviews'];
            }
            reviews['locationName'] = loc['name'];
            if (!isNullOrUndefined(loc['reviewSettings']) && loc['reviewSettings']['isActive'] == true) {
              reviews['isActive'] = true;
            }
            else {
              reviews['isActive'] = false;
            }
            if (!isNullOrUndefined(loc['reviewSettings']) && loc['reviewSettings']['status']) {
              reviews['status'] = loc['reviewSettings']['status'];
            }
            else {
              reviews['status'] = 'no-batch';
            }
            if (!isNullOrUndefined(loc['reviewSettings']) && loc['reviewSettings']['batchId']) {
              reviews['batchId'] = loc['reviewSettings']['batchId'];
            }

            if (!isNullOrUndefined(loc['reviewSettings']) && loc['reviewSettings']['urls']) {
              reviews['urls'] = loc['reviewSettings']['urls'];
            }
            if (!isNullOrUndefined(loc['reviewSettings']) && loc['reviewSettings']['activeIndex']) {
              reviews['activeIndex'] = loc['reviewSettings']['activeIndex'];
            }

            reviews['locationCode'] = loc.$key;
            reviews['facilityKey'] = this.key;

            this.locationStatus.push(reviews);
          }
          console.log(this.locationStatus);

        });
      });

    });
    this.items = [
      {
        label: 'Create New Batch',
        command: (event: any) => {
          this.facilityReviewsData.activeIndex = 0;
        }
      },
      {
        label: 'Add Urls to Batch',
        command: (event: any) => {
          this.facilityReviewsData.activeIndex = 1;
        }
      },
      {
        label: 'Submit Batch',
        command: (event: any) => {
          this.facilityReviewsData.activeIndex = 2;
        }
      },
      {
        label: 'Retrieve Reviews From Batch',
        command: (event: any) => {
          this.facilityReviewsData.activeIndex = 3;
        }
      }
    ];
  }

  toggleReviews(e) {
    console.log(e);
    this.clientData.reviewSettings.isActive = e.checked;
    this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings).then((d) => {
      this.afService.openSnackBar('Review Settings Updated');
    });
  }

  saveReviewSettings() {
    this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings).then((d) => {
      this.afService.openSnackBar('Review Settings Updated');
    });
  }

  toggleUpdateMonthly(e) {
    // console.log(e);
    this.clientData.reviewSettings.updateEachMonth = e.checked;
    this.bl.toggleReviewsAutoUpdate(this.clientData.code, this.clientData.reviewSettings.updateEachMonth ? 'enable' : 'disable')
      .subscribe(rtn => {
        console.log('rtn', rtn);
        this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings)
          .then((d) => {
            this.afService.openSnackBar('Review Settings Updated');
          });
      },
        error => {
          console.warn('toggleReviewsAutoUpdate error caught:', error);
          this.afService.openSnackBar('ERROR!!');
        });
  }

  toggleReviewsSms(e: MdSlideToggleChange) {
    this.gConn.toggleClientReviewSms(this.clientData.code, e.checked ? 'enable' : 'disable')
      .subscribe(
        data => {
          console.log(data);
          this.clientData.reviewSettings.sendReviewsSms = e.checked;
          this.afService.saveFacilityReviewSettings(this.key, this.clientData.reviewSettings)
            .then(() => {
              this.afService.openSnackBar('Review Settings Updated');
            });
        },
        error => {
          console.error(error);
          this.afService.openSnackBar(`ERROR: ${ error.message }`, null, 6000);
        }
      );
  }

  loadReviewSettings() {
    let sub = this.afService.loadReviewSettings(this.key, this.selectedLocation.$key).subscribe((data) => {
      if (sub) {
        sub.unsubscribe();
      }

      console.log(data);
      if (data.$value == null) {
        if (!isNullOrUndefined(data.batchId)) {
          if (isNullOrUndefined(data.urls)) {
            data.urls = [];
          }
          this.facilityReviewsData = data;
          this.facilityReviewsData.activeIndex = data.activeIndex;
        }
        else {
          this.facilityReviewsData = new FacilityReviewsData();
        }
      }
      else {
        this.facilityReviewsData = new FacilityReviewsData();
      }
    });
  }

  updateFacilityReviewsToggle(e) {
    this.facilityReviewsData.isActive = e.checked;
    this.save();
  }

  addGoogleUrl() {
    this.newProfileUrl = this.googleString;
  }

  fetchReviews(facilityReviewsData) {
    this.afService.globalReviewsLoading = true;
    this.afService.isLoading = true;
    this.afService.getReviewSettingsResult(this.clientData.code, facilityReviewsData);
  }

  addReviewUrl() {
    this.afService.isLoading = true;
    this.error = '';
    // console.log('this.facilityReviewsData:', this.facilityReviewsData)
    // console.log('this.selectedLocation:', this.selectedLocation)
    this.bl.addUrlToBatch(this.newProfileUrl, this.facilityReviewsData.batchId, this.clientData.code, this.facilityReviewsData.locationCode, this.selectedLocation.name)
      .toPromise().then((data: any) => {
        console.log(data)
        if (data['ret'] == 'success') {
          this.facilityReviewsData.urls.push({ url: this.newProfileUrl });
          this.newProfileUrl = '';
          this.save();
        }
        else {
          this.afService.isLoading = false;
          this.error = data['msg'];
        }
      }).catch(err => { console.log(err) });

  }

  selectLocation(location) {
    this.selectedLocation = location;
    this.loadReviewSettings();
    console.log(location)
    this.googleString = "https://google.com/search?q=" + this.clientData.name.replace(/ /g, "+") + "+" + this.selectedLocation.address.replace(/ /g, "+") + "+" + this.selectedLocation.address2.replace(/ /g, "+");
  }

  createNewBatchWithSameData() {
    this.afService.isLoading = true;
    // console.log('this.facilityReviewsData:', this.facilityReviewsData)
    // console.log('this.selectedLocation:', this.selectedLocation)
    this.bl.createNewBatch(this.clientData.code, this.facilityReviewsData.locationCode, this.selectedLocation.name)
      .toPromise().then(async (data: any) => {
        console.log(data)
        if (data['ret'] == 'success') {
          this.facilityReviewsData.batchId = data['batch-id'];
          this.facilityReviewsData.activeIndex = 1;
          this.save();

          for (let url of this.facilityReviewsData.urls) {
            await this.autoAddReviewUrl(url.url);
          }

          this.facilityReviewsData.activeIndex = 2;
          this.facilityReviewsData.status = 'submitted';
          this.afService.submitReviewSettingsBatch(this.clientData.code, this.facilityReviewsData);
        }
        else {
          // this.afService.isLoading = false;
        }
      }).catch(err => { console.log(err) });
  }

  async addUrls(urls) {
    return new Promise((resolve: Function) => { resolve(true); });
  }

  autoAddReviewUrl(url) {
    // console.log('this.facilityReviewsData:', this.facilityReviewsData)
    // console.log('this.selectedLocation:', this.selectedLocation)
    return this.bl.addUrlToBatch(url, this.facilityReviewsData.batchId, this.clientData.code, this.facilityReviewsData.locationCode, this.selectedLocation.name)
      .toPromise().then((data: any) => {
        console.log(data)
        if (data['ret'] == 'success') {
          this.save();
          return new Promise((resolve: Function) => { resolve(true); });
        }
        else {
          return this.autoAddReviewUrl(url);
        }
      }).catch(err => { console.log(err) });
  }

  createNewBatch() {
    // console.log('this.facilityReviewsData:', this.facilityReviewsData)
    // console.log('this.selectedLocation:', this.selectedLocation)
    this.afService.isLoading = true;
    this.bl.createNewBatch(this.clientData.code, this.facilityReviewsData.locationCode, this.selectedLocation.name)
      .toPromise().then((data: any) => {
        console.log(data)
        if (data['ret'] == 'success') {
          this.facilityReviewsData.batchId = data['batch-id'];
          this.facilityReviewsData.urls = [];
          this.facilityReviewsData.activeIndex = 1;
          this.facilityReviewsData.facilityKey = this.key;
          this.facilityReviewsData.locationCode = this.selectedLocation.$key;
          this.save();
        }
        else {
          // this.afService.isLoading = false;
        }
      }).catch(err => { console.log(err) });
  }

  save() {
    console.log('save', this.key, this.selectedLocation.$key, this.facilityReviewsData);

    this.afService.saveReviewSettings(this.key, this.selectedLocation.$key, this.facilityReviewsData).then((data) => {
      this.afService.openSnackBar('Review Settings Updated');
      this.afService.isLoading = false;
    });
  }

  saveReviews(reviews) {
    this.afService.saveReviews(this.key, this.selectedLocation.$key, reviews).then((data) => {
      this.afService.saveReviewsFacility(this.key, this.selectedLocation.$key, reviews).then((data2) => {
        this.afService.openSnackBar('Review Settings Updated');
        this.afService.isLoading = false;
      });
    });
  }

  readyToSubmit() {
    this.afService.isLoading = true;
    this.facilityReviewsData.activeIndex = 2;
    this.facilityReviewsData.status = 'ready-to-submit';
    this.save();
  }

  submitBatch() {
    // console.log('this.facilityReviewsData:', this.facilityReviewsData)
    // console.log('this.selectedLocation:', this.selectedLocation)
    this.afService.isLoading = true;
    this.facilityReviewsData.status = 'submitted';
    this.save();
    this.afService.submitReviewSettingsBatch(this.clientData.code, this.facilityReviewsData);
  }

  // getResults() {
  //   this.showLoading = true;
  //   let sub = this.afService.getClientInfo(this.key).subscribe(client => {
  //     this.getResult(client.code);
  //     sub.unsubscribe();
  //   });
  // }

  // getResult(clientCode) {
  //   return this.bl.getResults(this.facilityReviewsData.batchId, clientCode).toPromise().then((data) => {
  //     if (data['ret'] == 'success') {
  //       this.showLoading = false;
  //       this.facilityReviewsData.activeIndex = 4;
  //       this.save();
  //       this.saveReviews(data['data']);

  //     }
  //     else {
  //       setTimeout(() => {
  //         this.getResult(clientCode);
  //       }, 10000);
  //     }
  //   });
  // }

  goBack() {
    this.router.navigate(['../../'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/facility-reviews/facility-reviews.component.ts